var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallary-content-area mv-h-full position-relative d-flex"},[_c('v-container',{staticClass:"mv-h-full ml-10"},[_c('mvWdGallaryInputVue')],1),_c('v-container',{staticClass:"mv-h-full"},[_c('mvWdGallaryOutputVue')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }